import apiClient, { unwrap } from './client'
import type { QueueConfig } from './types'

export type QueueConfigInput = Omit<QueueConfig, 'updated_at'>

export const queueConfigApi = {
  get() {
    return unwrap<QueueConfig>(apiClient.get('/queue-config'))
  },
  put(input: QueueConfigInput) {
    return unwrap<QueueConfig>(apiClient.put('/queue-config', input))
  },
}